<template>
  <div class="question">
    <p class="introduction">
      {{
        $language.current | translateToCurrentLang(question.introductionEs, question.introductionEn)
      }}
    </p>
    <h5 class="text">
      {{
        $language.current
          | translateToCurrentLang(question.textEs, question.textEn)
          | customVariablesFilter(customVariables, $language.current)
      }}
    </h5>
    <p
      class="description"
      v-if="question.description"
      v-html="
        $options.filters.translateToCurrentLang(
          $language.current,
          question.descriptionEs,
          question.descriptionEn,
        )
      "
    ></p>
    <div v-if="question.qType === MULTIPLE_CHOICE">
      <md-field>
        <md-select
          class="box"
          v-model="question.answer.option"
          @blur="onBlur"
          :style="{ width: '100%' }"
        >
          <md-option v-for="option in question.answerOptions" :key="option.id" :value="option.id">
            {{
              $language.current
                | translateToCurrentLang(option.textEs, option.textEn)
                | customVariablesFilter(customVariables, $language.current)
            }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div v-else-if="question.qType === MULTI_SELECT">
      <md-field>
        <md-select v-model="question.answer.options" md-dense multiple @md-selected="onChange">
          <md-option v-for="option in question.answerOptions" :key="option.id" :value="option.id">
            {{
              $language.current === 'es_ES' && option.textEs
                ? option.textEs
                : option.text | customVariablesFilter(customVariables, $language.current)
            }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div v-else-if="question.qType === FREE_TEXT" id="md-textarea">
      <textarea
        id="textarea"
        @input="mixin_TextAreaResize_resize"
        rows="1"
        @blur="onBlur"
        v-model="question.answer.text"
        required
        :placeholder="$gettext('Answer')"
      ></textarea>
    </div>
    <md-field v-else-if="question.qType === NUMBER">
      <md-input
        @blur="onBlur"
        v-model="question.answer.text"
        required
        v-mask="$data[question.inputMask] || numberMask"
        :style="{ borderBottom: '1px solid gray' }"
        :placeholder="$gettext('Answer')"
      ></md-input>
    </md-field>
    <div v-else-if="question.qType === DATE">
      <md-field class="input-field">
        <!-- <h5 v-translate>When it happened:</h5> -->
        <md-input
          v-model="question.answer.text"
          :placeholder="$gettext('MM/YYYY')"
          :style="{ borderBottom: '1px solid gray' }"
          @blur="$emit('fieldBlur')"
        ></md-input>
      </md-field>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Question from '@/services/surveyQuestions'
import TextAreaResize from '../../mixins/TextAreaResize'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
const currencyMask = createNumberMask({
  prefix: '$',
  allowDecimal: true,
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowNegative: false,
})
const numberMask = createNumberMask({
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowNegative: false,
})

export default {
  name: 'Question',
  props: {
    question: {
      type: Object,
      default: null,
    },
  },
  mixins: [TextAreaResize],
  data() {
    return {
      currencyMask,
      numberMask,
      MULTI_SELECT: Question.options.MULTI_SELECT,
      MULTIPLE_CHOICE: Question.options.MULTIPLE_CHOICE,
      NUMBER: Question.options.NUMBER,
      FREE_TEXT: Question.options.FREE_TEXT,
      DATE: Question.options.DATE,
    }
  },
  methods: {
    onChange() {
      this.$emit('answer-changed', this.question)
    },
    onBlur() {
      this.$emit('answer-changed', this.question)
    },
    textAreaAdjust(o) {
      o.style.height = '1px'
      o.style.height = 25 + o.scrollHeight + 'px'
    },
  },
  computed: {
    ...mapState(['organizationDetails']),
    customVariables() {
      return this.$options.filters.translateToCurrentLang(
        this.$language.current,
        this.organizationDetails.customVariablesEs,
        this.organizationDetails.customVariablesEn,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
h5 {
  margin-top: 5px;
}
.question {
  margin-bottom: 1.5rem;
}

.description {
  white-space: pre-wrap;
}

.text {
  margin-bottom: 0;
}

#textarea {
  overflow-y: scroll;
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
  font-size: 1rem;
  resize: none;
  padding: 0.5rem 0.5rem 0.5rem 0;
  max-height: 100px;
  min-width: 15rem;
  appearance: none;
  border-bottom: 1px solid $gray;
  font-family: 'Poppins-Light';
}

#md-textarea {
  width: 100%;
}
.introduction {
  margin: 3rem 0 2rem 0;
  font-style: italic;
  font-size: 0.9rem;
}
</style>
